<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">P Data Forms</strong>
        </div>
        <div class="col-md-2">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <vue-tabs v-model="selTab" direction="horizontal" @tab-change="getTabData">
        <v-tab :title="alg.name" v-for="(alg, index) in tabs" v-bind:key="index">
          <div class="row" v-if="alg.title!=='p11' && alg.title!=='s' && checkInArray(tabsWithoutBanks, alg.title)">
            <div class="col-md-12">
              <pForm  v-if="alg.title!=='s' && checkInArray(tabsWithoutBanks, alg.title)" :globaldata="globData" :pType="pDataType" ref="pfrm"></pForm>
            </div>
          </div>
          <div class="row" v-else-if="alg.title!=='p11' && alg.title!=='s' && checkInArray(tabsWithBanks, alg.title)">
            <div class="col-md-12">
              <pFormBank  v-if="alg.title!=='s' && checkInArray(tabsWithBanks, alg.title)" :globaldata="globData1" :pType="pDataType" ref="pfrm1"></pFormBank>
            </div>
          </div>
          <div class="row" v-else-if="alg.title==='s'">
            <div class="col-md-12">
              <pForm :globaldata="globData" :pType="pDataType" ref="pfrm"></pForm>
            </div>
          </div>
          <div class="row" v-else-if="alg.title==='p11'">
            <div class="col-md-12">
              <p11Form :globaldata="globData2" :pType="pDataType" ref="pfrm"></p11Form>
            </div>
          </div>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
  <!-- </card> -->
</template>  
<script>
import pForm from "@/views/manual-forms/p-form";
import p11Form from "@/views/manual-forms/p11-form";
import pFormBank from "@/views/manual-forms/p-form-bank";
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
export default {
  components: {
    pForm,
    pFormBank,
    p11Form
  },
  mixins: [commonMixins],
  data() {
    return {
      tabs: [
        { title: "p1", name: "P1", comp: "p1Form", type: "p1" },
        { title: "p2", name: "P2", comp: "p2Form", type: "p2" },
        { title: "p3", name: "P3", comp: "p3Form", type: "p3" },
        { title: "p4", name: "P4", comp: "p4Form", type: "p4" },
        { title: "p5a", name: "P5 A", comp: "p5aForm", type: "p5A" },
        { title: "p5b", name: "P5 B", comp: "p5bForm", type: "p5B" },
        { title: "p6a", name: "P6 A", comp: "p6aForm", type: "p6A" },
        { title: "p6b", name: "P6 B", comp: "p6bForm", type: "p6B" },
        { title: "p7a", name: "P7 A", comp: "p7aForm", type: "p7A" },
        { title: "p7b", name: "P7 B", comp: "p7bForm", type: "p7B" },
        { title: "p8a", name: "P8 A", comp: "p8aForm", type: "p8A" },
        { title: "p8b", name: "P8 B", comp: "p8bForm", type: "p8B" },
        { title: "p10", name: "P10", comp: "p10Form", type: "p10" },
        { title: "p11", name: "P11", comp: "p11Form", type: "p11" },
        { title: "q1", name: "Q1", comp: "q1Form", type: "q1" },
        { title: "q1_a", name: "Q1 A", comp: "q1aForm", type: "q1_a" },
        { title: "q1_b", name: "Q1 B", comp: "q1bForm", type: "q1_b" },
        { title: "q1_c", name: "Q1 C", comp: "q1cForm", type: "q1_c" },
        { title: "q1_d", name: "Q1 D", comp: "q1dForm", type: "q1_d" },
        { title: "s", name: "S", comp: "sForm", type: "s1" }
      ],
      tabsWithBanks: [
        'p2', 'p3', 'p5b', 'p6a', 'p7b', 'p10'
      ],
      tabsWithoutBanks: [
        'p1', 'p4', 'p5a', 'p6b', 'p7a', 'p8a', 'p8b', 'pq1', 'q1_a', 'q1_b', 'q1_c', 'q1_d'
      ],
      selTab: "",
      pDataType: "p1",
      globData: [],
      globData1: [],
      globData2: [],
    };
  },
  created() {
    console.log("GetPFormData");
    this.getPFormData();
    // if (!localStorage.getItem("pFormTab")) {
    //   // this.selTab = 'General Info';
    //   localStorage.setItem("pFormTab", "0");
    // } else {
    //   this.selTab =
    //     localStorage.getItem("pFormTab") === "0"
    //       ? ""
    //       : localStorage.getItem("pFormTab");
    // }
  },
  methods: {
    getTabData(tabIndex, newTab, oldTab) {
      console.log(tabIndex, newTab.title, oldTab);
      this.selTab = tabIndex;
      localStorage.setItem("pFormTab", this.selTab);
      this.pDataType = this.tabs[this.selTab].type;
      this.getPFormData();
    },
    getPFormData() {
      console.log("getPFormData", this.pDataType);
      http.get("getPFormData/" + this.pDataType, {}, (error, callback) => {
        if (this.checkInArray(this. tabsWithBanks, this.pDataType)) {
          this.globData1 = callback;
          console.log("GlobalDATA", this.globData);
        } else if (this.pDataType === 'p11') {
          this.globData2 = callback;
          console.log("GlobalDATA", this.globData);
        } else {
          this.globData = callback;
        }
      });
    }
  },
  computed: {
    widgetView() {
      if (this.selTab !== "") return this.tabs[this.selTab].comp;
      else return "p1Form";
    }
  }
};
</script>
<style>
form {
  padding: 10px;
}
form .col-md-3 {
  width: 40%;
}
</style>
/* .vue-tabs .nav-stacked > li {
  width: 100%;
}
.vue-tabs .nav > li span.title{
  justify-content: left;
}
.vue-tabs .nav-stacked > li + li {
  margin-right: 5px;
}
.left-vertical-tabs {
  width: 15%;
}
.tab-content.right-text-tabs {
  width: 85%;
}
.tab-content {
  border: none;
  border-left: 1px solid #c2cfd6 !important;
} */
</style>




// WEBPACK FOOTER //
// src/views/manual-forms/p-data-forms.vue